import { useEffect, useState } from "react";

const links = [
  { label: "首页", href: "#home" },
  { label: "地址汇总", href: "#address" },
  { label: "互换方法", href: "#switch" },
  { label: "可用检测", href: "#check" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:h-[72px] md:px-6">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
            <i className="ri-eye-fill" />
          </span>
          <span className="text-lg font-bold text-foreground-950 md:text-xl">吃瓜导航指南站</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#address"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            存好备用地址
          </a>
        </nav>

        <button
          type="button"
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-900 md:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </div>

      {open && (
        <nav className="mx-4 mb-3 rounded-xl border border-background-200 bg-background-50 p-2 md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="flex items-center justify-between rounded-lg px-4 py-3 text-sm text-foreground-800 hover:bg-background-100"
            >
              {l.label}
              <i className="ri-arrow-right-s-line" />
            </a>
          ))}
          <a
            href="#address"
            onClick={() => setOpen(false)}
            className="mt-1 flex items-center justify-center whitespace-nowrap rounded-lg bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
          >
            存好备用地址
          </a>
        </nav>
      )}
    </header>
  );
}